import { CommonModule, DatePipe } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, Title } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AdminRoutingModule } from "./admin/admin-routing.module";
import { AdminModule } from "./admin/admin.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CustomerRoutingModule } from "./customer/customer-routing.module";
import { CustomerModule } from "./customer/customer.module";
import { MaterialModule } from "./material/material-module";
import { SharedModulesModule } from "./shared-modules/shared-modules.module";
import { TruckOwnerRoutingModule } from "./truck-owner/truck-owner-routing.module";
import { TruckOwnerModule } from "./truck-owner/truck-owner.module";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { GoogleMapsModule } from "@angular/google-maps";
import { CorporateModule } from "./corporate/corporate.module";
import { CorporateRoutingModule } from "./corporate/corporate-routing.module";
import { SharedModulesRoutingModule } from "./shared-modules/shared-modules-routing.module";
import { DownloadComponent } from "./download/download.component";
import { environment } from "src/environments/environment.prod";

const config: SocketIoConfig = {
  url: `${environment.base_url}`,
  options: {},
};
@NgModule({
  declarations: [AppComponent, SidebarComponent, DownloadComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SocketIoModule.forRoot(config),
    AppRoutingModule,
    FormsModule,
    CommonModule,
    RouterModule,
    SharedModulesModule,
    MaterialModule,
    CustomerRoutingModule,
    AdminRoutingModule,
    CustomerModule,
    AdminModule,
    CorporateModule,
    ReactiveFormsModule,
    HttpClientModule,
    TruckOwnerModule,
    TruckOwnerRoutingModule,
    CorporateRoutingModule,
    SharedModulesRoutingModule,
    GoogleMapsModule,
  ],
  providers: [DatePipe, Title],
  bootstrap: [AppComponent],
})
export class AppModule {}
